module.exports = __webpack_public_path__ + "assets/img/reward_border.cb1004eb.png";